<template>
    <div class="mini-basket">
        <a :href="url" data-newwindow class="basket-link mini-link has-items">
            <img :src="imgPath" alt="">
            <span v-if="countBasketItems" class="count">{{countBasketItems}}</span>
        </a>
        <div class="tooltip">
            {{basketTitle}}
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    /**
     * Компонент для отображения в шапке сайта количества товаров добавленых в корзину
     *
     * @vuedoc
     * @module vue:components/MiniBasket
     * @exports vue:components/MiniBasket
     */

    export default {
        name: "mini-top-basket",

        components: {
        },

        props: [
            'title', 'img_src', 'url'
        ],
        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {string} basketTitle - Значение в тултипе в зависемости от языка на сайте
         */
        data() {
            return {
                basketTitle: this.title,
                imgPath: this.img_src,
            }
        },

        computed: {
            ...mapGetters('basket', [
                'basketItems',
                'basketCount'
            ]),

            /**
             *  Вычисляемое свойство которое получает список товаров в корзине
             *
             * @method getBasketItems
             */
            getBasketItems() {
                if(typeof this.basketItems !== 'undefined') {
                    return this.basketItems;
                }
            },

            /**
             *  Вычисляемое свойство которое определяет количество товаров в корзине
             *
             * @method countBasketItems
             */
            countBasketItems() {
                return this.basketCount;
            },
        },

        mounted(){
        },

        methods: {
        }
    }


</script>
